/**
 * OsesAtrasadasWidget — OSEs em atraso com parceiros terceirizados.
 */
import React from "react";
import { Link } from "react-router-dom";

import { listarOses } from "../../../services/terceirizacao";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "oses_atrasadas",
  label: "OSEs atrasadas",
  descricao: "Ordens de serviço externo (terceirizadas) fora do SLA.",
  categoria: "Pendencias",
  permissoes: ["terceirizacao:view"],
  tamanho_default: "S",
  essencial: false,
};

export async function fetchData(request) {
  const payload = await listarOses(request, { atrasadas: true, pageSize: 1 });
  const c = Array.isArray(payload) ? payload.length : (payload?.count ?? (payload?.results || []).length);
  return { atrasadas: c };
}

export function Widget({ dados }) {
  const c = dados?.atrasadas ?? 0;
  return (
    <>
      <CardBody>
        <KpiValor style={{ color: c > 0 ? "var(--danger-text)" : undefined }}>{c}</KpiValor>
        <KpiSub>
          {c > 0 ? "OSEs fora do SLA" : "Tudo em dia com parceiros."}
        </KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/terceirizacao/oses">Ver OSEs</LinkLight>
      </CardFooter>
    </>
  );
}
